import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs/internal/Observable";
import { GetDataDTO } from "../schema/Common/GetDataDTO";
import { GetQueryParametersDTO } from "../schema/Common/GetQueryParametersDTO";
import { SubscriptionDTO } from "../schema/Subscription/SubscriptionDTO";
import { UserBulkRequestDTO } from "../schema/User/UserBulkRequestDTO";
import { UserBulkRequestTypeDTO } from "../schema/User/UserBulkRequestTypeDTO";
import { UserPlanDTO } from "../schema/User/UserPlanDTO";
import { UsuarioDTO } from "../schema/User/UsuarioDTO";
import { UsuarioInsertDTO } from "../schema/User/UsuarioInsertDTO";
import { SetPasswordTO } from "../schema/User/set-password-to";

@Injectable({
    providedIn: "root"
})
export class ApiUsersService {
    relativePath: string;
    constructor(private http: HttpClient) {
        this.relativePath = `${environment.admin.url}/api/v1/user`;
    }

    create(usuarioTO: UsuarioInsertDTO): Observable<UsuarioDTO> {
        return this.http.post<UsuarioDTO>(this.relativePath, JSON.stringify(usuarioTO), {
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            }
        });
    }

    get(
        find = "",
        orderBy = "nome",
        sortOrder = "asc",
        skip = 0,
        take = 10,
        groupId?: string,
        active = true
    ): Observable<GetDataDTO<UsuarioDTO>> {
        let params: HttpParams = new HttpParams()
            .set("skip", skip.toString())
            .set("take", take.toString())
            .set("sortOrder", sortOrder.toString())
            .set("find", find)
            .set("orderBy", orderBy)
            .set("active", active.toString());

        if (groupId) params = params.set("groupId", groupId);

        return this.http.get<GetDataDTO<UsuarioDTO>>(this.relativePath, {
            params: params
        });
    }

    getById(id: string): Observable<UsuarioDTO> {
        return this.http.get<UsuarioDTO>(`${this.relativePath}/${id}`);
    }

    update(id: string, usuarioTO: UsuarioDTO): Observable<UsuarioDTO> {
        return this.http.put<UsuarioDTO>(`${this.relativePath}/${id}`, usuarioTO);
    }

    setPassword(id: string, setPassword: SetPasswordTO): Observable<any> {
        return this.http.patch<any>(`${this.relativePath}/${id}/set-password`, setPassword);
    }

    removeDocument(id: string, name: string): any {
        return this.http.delete<any>(`${this.relativePath}/${id}/document/${name}`);
    }

    uploadDocument(id: string, document: File): any {
        const formData = new FormData();
        formData.append("file", document);
        return this.http.post<any>(`${this.relativePath}/${id}/document`, formData);
    }

    uploadFileCustomField(userId: string, document: File, fieldKey: string): Observable<any> {
        const formData = new FormData();
        formData.append("file", document);

        const params = new HttpParams().set("fieldKey", fieldKey);

        return this.http.post<any>(`${this.relativePath}/${userId}/fileCustomField`, formData, {
            params: params
        });
    }

    deleteFileCustomField(userId: string, fieldKey: string): Observable<any> {
        const param = new HttpParams().set("fieldKey", fieldKey);

        return this.http.delete<any>(`${this.relativePath}/${userId}/fileCustomField`, {
            params: param
        });
    }

    getUrlFileCustomField(userId: string, fieldKey: string): Observable<string> {
        const param = new HttpParams().set("fieldKey", fieldKey);

        return this.http.get(`${this.relativePath}/${userId}/UrlFileCustomField`, {
            params: param,
            responseType: "text"
        });
    }

    getUserCrossSubscriptions(userId: string, find = "", skip = 0, take = 10): Observable<GetDataDTO<SubscriptionDTO>> {
        const param = new HttpParams().set("skip", skip.toString()).set("take", take.toString()).set("find", find);

        return this.http.get<GetDataDTO<SubscriptionDTO>>(`${this.relativePath}/${userId}/cross-subscriptions`, {
            params: param
        });
    }

    createBulk(
        bulkFile: File,
        userQueryParametersTO: GetQueryParametersDTO | null,
        type: UserBulkRequestTypeDTO
    ): Observable<UserBulkRequestDTO> {
        const formData = new FormData();
        if (bulkFile) {
            formData.append("file", bulkFile);
        }

        //TODO: isso ficou mt feio, deve haver uma forma melhor
        if (userQueryParametersTO) {
            formData.append("userQueryParametersTO[skip]", userQueryParametersTO.skip.toString());
            formData.append("userQueryParametersTO[take]", userQueryParametersTO.take.toString());
            formData.append("userQueryParametersTO[find]", userQueryParametersTO.find);
            formData.append("userQueryParametersTO[sortOrder]", userQueryParametersTO.sortOrder);
            formData.append("userQueryParametersTO[orderBy]", userQueryParametersTO.orderBy);

            if (userQueryParametersTO.active != null) {
                formData.append("userQueryParametersTO[active]", userQueryParametersTO.active.toString());
            }
        }
        formData.append("type", type);

        return this.http.post<UserBulkRequestDTO>(`${this.relativePath}/bulk`, formData);
    }

    getBulk(id: string): Observable<UserBulkRequestDTO> {
        return this.http.get<UserBulkRequestDTO>(`${this.relativePath}/bulk/${id}`);
    }

    addUserPlan(userId: string, plan: UserPlanDTO): Observable<any> {
        return this.http.post(`${this.relativePath}/${userId}/plan`, plan);
    }

    updateUserPlan(userId: string, plan: UserPlanDTO): Observable<any> {
        return this.http.patch(`${this.relativePath}/${userId}/plan/${plan.id}`, plan);
    }

    removeUserPlan(userId: string, planId: string): Observable<any> {
        return this.http.delete(`${this.relativePath}/${userId}/plan/${planId}`);
    }
}
